import type { Activity } from "../types";

export function localizeActivity(activity: Activity, translation?: Record<string, string | null>): Activity {
  if (!translation) return activity;
  const translated = { ...activity };
  for (const field of ["title", "prompt", "say_this", "observe_for", "evidence_hint", "parent_move", "child_move", "what_to_do", "story"] as const) {
    const value = translation[field];
    if (value?.trim()) translated[field] = value;
  }
  return { ...translated, area: activity.area, area_label: translation.area?.trim() || activity.area,
    original: { title: activity.title, prompt: activity.prompt, say_this: activity.say_this } };
}

export function isMissingTranslationColumns(error: { code?: string; message?: string } | null) {
  return Boolean(error && ["42703", "PGRST204"].includes(error.code ?? "") && /(?:title|body|note)_ur/.test(error.message ?? ""));
}
